import styled from 'styled-components';
import Button from '../Button';

export const TopBarButton = styled(Button)`
  margin: 0;
  display: flex;
  gap: 6px;
  align-items: center;
  width: fit-content;
  white-space: pre;
`;

export const LeftButton = styled(TopBarButton)`
  grid-area: close;
  justify-self: start;
`;

export const RightButton = styled(TopBarButton)`
  grid-area: switch-mode;
  justify-self: end;
`;
